import { FC } from "preact/compat";
import { useApp } from "~/core/store";
import { SlideText, TimeDistance } from "~/components";
import { useBreakpoint } from "~/hooks";
import { TrackerMobile } from "~/organisms";
import cn from "classnames";

const MobileHeadline: FC = () => {
    const bpMd = useBreakpoint("md");
    const {
        breadcrumbs,
        tracker: { activeExternal, activeTask, activeTile },
        mobile,
    } = useApp();
    const last = breadcrumbs.items.value[breadcrumbs.items.value.length - 1];

    if (bpMd.value) {
        return null;
    }

    const active = activeTask.value ?? activeTile.value ?? activeExternal.value;

    return (
        <div className="flex items-center">
            <div className="flex w-full items-center justify-between rounded-full bg-white/15 px-4 py-1 font-bold text-white backdrop-blur">
                <SlideText
                    className="w-full text-left"
                    textClassName={cn(
                        "truncate !origin-top-left",
                        active?.startDate
                            ? "max-w-[calc(100vw-100px-5rem)]"
                            : "max-w-[calc(100vw-100px-3rem)]",
                    )}
                >
                    {mobile.menuHeadline.value ??
                        last?.mobileTitle ??
                        last?.name ??
                        "Engage"}
                </SlideText>
                {active?.startDate && (
                    <TimeDistance date={active.startDate} className="text-sm" />
                )}
            </div>
            <TrackerMobile />
        </div>
    );
};

export default MobileHeadline;
